<template>
  <div class="original-bill">
    <div class="header">
      <el-input class="query" v-model.trim="orderNo" placeholder="请输入订单号" clearable @keyup.native.enter="getList(1)" @clear="getList(1)"></el-input>
        <el-select class="query" v-model="orderType" placeholder="请选择审核状态">
            <el-option
              v-for="item in orderTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
        </el-select>
      <el-button type="primary" @click="getList(1)">查询</el-button>
    </div>
    <Table :data="datalist" :columns="columns" :pages="pages"></Table>
  </div>
</template>
<script>
import OrderService from "@/apis/orderService";
import Table from "@/components/new-table.vue";
import { BillOrderType, BillStatementColor, BillStatementState, PayMethods, PayWay } from "@/service/enum";
export default {
  components: { Table },
  data() {
    return {
      orderTypeList:[{
          value: '0',
          label: '全部'
        }, {
          value: '1',
          label: '待审核'
        }, {
          value: '2',
          label: '已通过'
        }, {
          value: '3',
          label: '已驳回'
        }],
      orderType:"0",
      orderNo: "",
      merName: "",
      datalist: [],
      columns: [
        { label: "订单号", prop: "orderNo", "min-width": "150px" },
        { label: "应用名称", prop: "orderName", "min-width": "80px" },
        { label: "创建时间", prop: "applyDate", "min-width": "100px" },
        
        {
          label: "审核状态", render: (h,  scope ) => {
            return <span class={scope.row.auditStatus == 1 ? "" : scope.row.auditStatus == 2 ? "ytg" : "ybh"}>{this.getTypeName(scope.row)}</span>
          }
        },
        {
          label: "订单状态", render: (h,  scope ) => {
            return <span>{this.getOrderTypeName(scope.row)}</span>
          }
        },
        {
          label: "凭证", valueType: 0, width: "130",
          render: (h, scope) => {
            return (<el-image 
                              style="width: 50px; height: 50px;margin-top:3px"
                              src={this.$fileBaseUrl + '50x50/' + scope.row.payVoucher}
                              preview-src-list={[this.$fileBaseUrl + 'x/' + scope.row.payVoucher]}>
            </el-image>)
          }
        },
        {
          label: "操作", render: (h, { row }) => {
            return <el-button type="text" onClick={() => { this.openreviewinfo(row) }}>{row.auditStatus==2 || row.auditStatus==3 || row.orderState == 3?"详情":'审核'}</el-button >
          }
        },
      ],
      pages: {
        props: {
          total: 0,
          "page-size": 20,
          "current-page": 1,
        },
        on: {
          "current-change": this.currentChange,
          "size-change": this.sizesChange
        },
      },
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    getTypeName(row){
      if(row.orderState == 3){
        return '已取消'
      
      }else{
          return row.auditStatus == 1 ? "待审核" : row.auditStatus == 2 ? "已通过" : "已驳回"
      }
      
    },
    getOrderTypeName(row){
      const OrderStateLabel = {
        "-3": "已取消",
        "-1": "全部",
        "0": "待支付",
        "1": "已支付",
        "2": "已退款",
        "3": "已取消",
        "4": "退款中",
        "5": "部分退款",
      };
      if(row.orderState == 3){
        return '已取消'
      }else{
        return row.auditStatus==3?"":row.auditStatus == 1?"待支付":OrderStateLabel[row.orderState]
      }
      
    },
    openreviewinfo(row){
       this.$router.push({ path: "/payreview/pay-reviewinfo", query: { id:row.id}})
    },
    getList(page) {
      const pageIndex = page || this.pages.props["current-page"];
      const pageSize = this.pages.props["page-size"];
      const params = {
        pageIndex,
        pageSize,
        auditStatus: this.orderType,
        orderNo: this.orderNo?this.orderNo:"",
      }
      OrderService.getOfflineOrderList(params).then(res => {
        this.datalist = res.data
        // this.datalist = res.data.map(i => {
        //   i.orderTypeLabel = BillOrderType[i.orderType];
        //   i.billStatusLabel = BillStatementState[i.billStatus];
        //   i.billStatusColor = BillStatementColor[i.billStatus];
        //   i.payMethodLabel = i.payMethod ? PayMethods[i.payMethod] : "-";
        //   i.payTheWayLabel = i.payTheWay ? PayWay[i.payTheWay] : "-";
        //   i.serviceFee = (i.platformBillMoney + i.serviceCharge).toFixed(2) //服务费=平台的结算金额+手续费
        //   return i;
        // });
        this.pages.props.total = res.dataCount;
      });
    },
    sizesChange(val) {
      this.pages.props["page-size"] = val;
      this.getList(1);
    },
    currentChange(page) {
      this.pages.props["current-page"] = page;
      this.getList();
    },
  }
}
</script>

<style lang="scss" scoped>
.original-bill {
  display: flex;
  flex-direction: column;
}
.header {
  margin-bottom: 20px;
}
.query {
  width: 200px;
  margin-right: 20px;
  vertical-align: middle;
}
.state {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .state-dot {
    width: 5px;
    margin-right: 5px;
    height: 5px;
    border-radius: 50%;
  }
}
::v-deep .ytg{
  color: rgb(103, 217, 25) !important;
}
::v-deep .ybh{
  color:rgb(218, 18, 18) !important;
}
</style>